import Footer from "../components/Footer";
import Header from "../components/Header";
import React, {useEffect} from "react";
import { Link } from "react-router-dom";

import MetaComponent from "../components/MetaComponent";
import usePageReady from "../../shared/usePageReady";
const metadata = {
    title: `Page Not Found || ${process.env.REACT_APP_META_TITLE}`,
    description: process.env.REACT_APP_META_DESCRIPTION,
};
export default function NotFoundPage({ onPageReady }) {
    usePageReady(onPageReady);
    return (
        <>
            <MetaComponent meta={metadata} />
            <Header />
            <section className="flat-spacing">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="wg-404">
                                <div className="image">
                                    <img
                                        src="/images/banner/404.png"
                                        data-=""
                                        alt={404}
                                        className="lazyload"
                                        width={472}
                                        height={472}
                                    />
                                </div>
                                <p className="title">Whoops!</p>
                                <p className="text-md sub text-main">
                                    We couldn’t find the page you were looking for.
                                </p>
                                <div className="bot">
                                    <Link to={`/`} className="tf-btn btn-fill animate-btn">
                                        Return to Homepage
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </>
    );
}
